<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import {
        loadOptions,
        optionToValue,
        valueToOption,
    } from '$components/Form/SelectCategory/utils';
    import { getContainer } from '$components/Context/ContainerContext';
    import MobileComboboxRow from '$components/Form/ModalMobile/MobileComboboxRow.svelte';
    import Highlighter from '$components/Highlighter.svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let label: string;
    export let required: boolean = false;
    export let id: string | null = null;
    export let prefixId: string | undefined = undefined;
    export let modalTitle: string | null = null;

    export let leaf: boolean | null = null;
    export let parentId: number | null = null;

    const { apollo } = getContainer();
</script>

<MobileComboboxRow
    {form}
    {field}
    {label}
    {required}
    {prefixId}
    {id}
    {modalTitle}
    loadOptions={(q) => loadOptions(apollo, q, leaf, parentId)}
    {optionToValue}
    valueToOption={(v) => valueToOption(apollo, v)}
>
    <svelte:fragment slot="description" let:option let:class={className}>
        {#if option != null}
            <span class={className}>{option.name}</span>
        {/if}
    </svelte:fragment>

    <div slot="option" let:option let:inputValue>
        <span>
            <Highlighter
                text={option.name}
                query={inputValue}
                class="m-0 p-0"
                highlightClass="font-bold"
            />
        </span>
        {#if option.parent != null}
            <div class="text-sm text-gray-600">
                <Highlighter
                    text={option.parent.name}
                    query={inputValue}
                    class="m-0 p-0"
                    highlightClass="font-bold"
                />
            </div>
        {/if}
    </div>
</MobileComboboxRow>
